<template>
    <div class="popup">
        <header
            role="navigation"
            class="navbar navbar-expand navbar-dark py-1 px-3"
        >
            <div class="flex-grow-1"></div>
            <a
                href="#"
                class="nav-link p-0"
            >
                <button
                    type="button"
                    class="close"
                    aria-label="Close"
                    @click="hideLoginPopup"
                    v-bind:disabled="authBusy"
                >
                    <font-awesome-icon :icon="['fas', 'times']" />
                </button>
            </a>
        </header>

        <div class="container-fluid d-flex flex-column justify-content-center align-items-center">
            <form
                class="accesso-login text-center my-1"
                method="post"
                @submit.prevent="onSubmitLogin"
            >
                <div
                    class="form-group mb-0"
                    v-show="!recoveryPasswordSent"
                >
                    <label class="d-block mb-0 text-uppercase font-weight-bold text-tiffany">{{ popupTitle }}</label>
                    <label
                        class="d-block mt-1 mb-0 text-danger"
                        v-html="popupMessage"
                    ></label>
                    <label
                        class="mb-0 mt-3 font-light-rikorda"
                        v-show="!showPasswordForgot"
                    >{{ $t("Nome utente") }}</label>
                    <div class="custom-control form-group mb-0 mt-1 mr-0 pl-0">
                        <input
                            type="email"
                            id="loginEmail"
                            ref="loginEmail"
                            name="loginUsername"
                            class="text-center w-100 form-control rounded-pill rilievo-ombra-interna"
                            v-model="loginUsername"
                        />
                    </div>
                    <label
                        class="mb-0 mt-3 font-light-rikorda"
                        v-show="!showPasswordForgot"
                    >{{ $t("Password") }}</label>
                    <div
                        class="custom-control form-group mb-0 mt-1 mr-0 pl-0"
                        v-show="!showPasswordForgot"
                    >
                        <input
                            type="password"
                            id="loginPassword"
                            name="loginPassword"
                            class="text-center w-100 form-control rounded-pill rilievo-ombra-interna"
                            v-model="loginPassword"
                            @focus="resetValidateLoginPwdError"
                            v-bind:disabled="authBusy"
                        />
                    </div>
                </div>
                <div v-show="!showPasswordForgot">
                    <span
                        class="mt-1 text-danger"
                        v-show="validateLoginPwdError"
                    >{{ $t(validateLoginPwdError) }}</span>
                </div>
                <div
                    class="mt-3 font-light-rikorda"
                    v-show="!showPasswordForgot && !recoveryPasswordSent"
                >
                    <div class="p-0">
                        <a
                            href="#"
                            @click="showPasswordForgotInfo"
                        >{{ $t("Password dimenticata") }}</a>
                    </div>
                </div>

                <button
                    type="submit"
                    class="btn btn-dark btn-rikorda1 mt-3"
                    v-bind:disabled="authBusy"
                    v-show="!showPasswordForgot && !recoveryPasswordSent"
                >{{ $t("Login") }}</button>
                <div
                    class="mt-3"
                    v-show="showPasswordForgot && !recoveryPasswordSent"
                >
                    {{ $t('Se hai dimenticato la tua password, inserisci la tua email e clicca su "Invia".') }}
                    <br />
                    {{ $t('Ti verrà inviata una e-mail per modificare la password.') }}
                </div>
                <div
                    class="mt-3"
                    v-if="recoveryPasswordSent"
                >{{ $t('Ti abbiamo inviato una mail che ti consentirà di reimpostare la password.') }}</div>
                <button
                    type="submit"
                    class="btn btn-dark btn-rikorda1 mt-3"
                    v-bind:disabled="authBusy"
                    v-show="showPasswordForgot && !recoveryPasswordSent"
                    @click="sendRecoveryPassword"
                >{{ $t("Invia") }}</button>
            </form>
        </div>
        <footer class="py-1 px-3"></footer>
    </div>
</template>

<script>
export default {
    name: "GalleryPopupLogin",

    props: {
        username: { type: String, required: false, default: "" }
    },

    data() {
        return {
            popupTitle: "",
            popupMessage: "",
            authBusy: false,
            recoveryPasswordSent: false,
            loginUsername: "",
            loginPassword: "",
            showPasswordForgot: false,
            validateLoginPwdError: false,
            user: null
        };
    },

    mounted() {
        if (this.username.length > 0) {
            this.loginUsername = this.username;
            this.$refs.loginEmail.disabled = true;
            this.popupTitle = this.$t("Email esistente");
            this.popupMessage = this.$t("existingMailMsg");
        } else {
            this.popupTitle = this.$t("Accedi a Rikorda");
            this.popupMessage = "";
        }
    },

    methods: {
        isPrivateEvent() {
            return this.$store.getters.isPrivateEvent;
        },

        hideLoginPopup() {
            if (this.recoveryPasswordSent || this.showPasswordForgot) {
                this.recoveryPasswordSent = false;
                this.showPasswordForgot = false;
            } else {
                this.$emit("close");
            }
        },

        resetValidateLoginPwdError() {
            this.validateLoginPwdError = false;
        },

        showPasswordForgotInfo: function () {
            this.showPasswordForgot = true;
        },

        sendRecoveryPassword: function () {
            this.authBusy = true;

            return this.$api
                .resetPassword(this.loginUsername)
                .then(() => {
                    this.authBusy = false;
                    this.recoveryPasswordSent = true;
                })
                .catch((error) => {
                    //TODO fare il popup con errore
                    alert("Recupera password: errore. Riprovare");
                    console.error(error);
                    this.authBusy = false;
                });
        },

        onSubmitLogin: function () {
            if (!this.loginPassword) {
                this.validateLoginPwdError = "Inserire la password";
                return;
            }

            this.authBusy = true;

            return this.$api
                .login(this.loginUsername, this.loginPassword)
                .then((loginData) => {
                    this.user = loginData.user;
                    this.$emit("login", loginData);
                    this.authBusy = false;
                })
                .catch((error) => {
                    //TODO fare il popup con errore
                    alert("Impossibile eseguire il login. Riprovare");
                    console.error(error);
                    this.authBusy = false;
                });
        }
    }
};
</script>

<style scoped>
div.popup {
    width: 100vw;
    height: 100vh;
    overflow-x: hidden;
    background: rgba(255, 255, 255, 0.9);
    max-width: none;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 200000;
    position: fixed;
    top: 0;
    right: 0;
    padding-left: 1rem;
}

div.popup .navbar {
    background: transparent;
}

div.popup footer {
    height: 33px;
}

div.popup .navbar .close,
div.popup .navbar .close:hover,
div.popup .navbar .close:focus {
    color: rgb(0, 0, 0);
}
</style>
